import { Select } from '@vestigas/ui';

import {
  type FilterDraftValue,
  type UniversalBuiltInDrawerFieldConfig,
} from '../../types';

type StaticSelectDrawerFieldConfig = Extract<
  UniversalBuiltInDrawerFieldConfig,
  { input: 'multiSelect' | 'singleSelect' }
>;

type StaticSelectDrawerFieldControlProps = {
  readonly fieldConfig: StaticSelectDrawerFieldConfig;
  readonly onChange: (next?: FilterDraftValue) => void;
  readonly testId: string;
  readonly value: string | string[];
};

export function StaticSelectDrawerFieldControl({
  fieldConfig,
  value,
  onChange,
  testId,
}: StaticSelectDrawerFieldControlProps) {
  const isMultiSelect = fieldConfig.input === 'multiSelect';
  const options =
    fieldConfig.options?.map((option) => ({
      draftValue: option.value,
      label: option.label,
      value: String(option.value),
    })) ?? [];

  return (
    <Select
      className="min-w-56"
      isClearable={false}
      isMultiSelect={isMultiSelect}
      options={options}
      placeholder={fieldConfig.placeholder}
      testId={testId}
      value={value}
      onChange={(next) => {
        const nextValues = (Array.isArray(next) ? next : [next])
          .filter(Boolean)
          .map(
            (nextValue) =>
              options.find((option) => option.value === nextValue)
                ?.draftValue ?? nextValue,
          );

        if (!isMultiSelect) {
          onChange(nextValues[0]);
          return;
        }

        onChange(
          nextValues.length === 0
            ? undefined
            : (nextValues as FilterDraftValue),
        );
      }}
    />
  );
}
